// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"128edbc8","839":"ca95097c"}[chunkId] + ".chunk.js";
};